import { Skeleton } from "@/components/ui/skeleton";

export function TarefaDetailSkeleton() {
  return (
    <div className="space-y-6 pb-10 duration-500 animate-in fade-in">
      <div className="flex items-center justify-between border-b border-border/50 pb-6">
        <div className="space-y-3">
          <Skeleton className="h-4 w-24 rounded-full" />
          <Skeleton className="h-10 w-[400px] rounded-lg" />
        </div>
        <Skeleton className="h-10 w-64 rounded-full" />
      </div>
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
        <div className="space-y-8 lg:col-span-8">
          <Skeleton className="h-40 w-full rounded-2xl" />
          <Skeleton className="h-[500px] w-full rounded-2xl" />
        </div>
        <div className="space-y-6 lg:col-span-4">
          <Skeleton className="h-[400px] w-full rounded-2xl" />
          <Skeleton className="h-[200px] w-full rounded-2xl" />
        </div>
      </div>
    </div>
  );
}
